module.exports = __webpack_public_path__ + "img/16csm_Ersa_VERSAFLOW-ONE-01-1920x540px_fdbff5b863.8500175f.jpg";